export default "__VITE_ASSET__Nzk3WvGL__"